
export default {
  data: () => ({
    isDesktop: false,
    eventsAttached: false,
    isCalendlyActive: false,
    linkCalendly: null,
    servicesHero: [
      "Site web",
      "Référencement naturel",
      "Référencement Google Ads",
      "Réseaux sociaux",
      "Logos & supports imprimés",
    ],
    medias: [
      {
        logo: "logo-le-figaro-white",
        alt: "logo le Figaro",
        link: "https://www.lefigaro.fr/services/aleo-l-agence-web-n01-dans-la-creation-de-sites-internet-pour-les-tpe-pme-20210716",
        width: "138",
        height: "21",
      },
      {
        logo: "logo-bfm-business-white",
        alt: "logo BFM Business",
        link: "https://www.bfmtv.com/economie/professionnels/aleo-l-agence-de-communication-pour-tpe-pme-qui-va-propulser-votre-activite_AN-202107290333.html",
        width: "60",
        height: "60",
      },
      {
        logo: "logo-challenges-white",
        alt: "logo Challenges",
        link: "https://www.challenges.fr/entreprise/aleo-l-agence-de-communication-100-dediee-aux-tpe-pme_773971",
        width: "136",
        height: "34",
      },
      {
        logo: "logo-la-tribune-white",
        alt: "logo La Tribune",
        link: "https://www.latribune.fr/supplement/comment-l-agence-web-aleo-souhaite-booster-la-presence-en-ligne-des-tpe-pme-890514.html",
        width: "101",
        height: "34",
      },
      {
        logo: "logo-forbes-white",
        alt: "logo Forbes",
        link: "https://www.forbes.fr/brandvoice/10000-entreprises-conquises-pour-aleo-lagence-web-n1-des-tpe-pme/",
        width: "90",
        height: "23",
      },
    ],
    // Communiquer en ligne, un vrai casse-tête quand on est une TPE.
    communicationArguments: [
      {
        title: "Les agences classiques et freelances, pas pour vous !",
        text: "Entre tarifs qui s’envolent, manque de disponibilité et suivi interminable, vous n’avez ni l’envie ni l’énergie de courir après des prestataires qui ne connaissent pas les réalités du marché lyonnais.",
      },
      {
        title: "La communication digitale, c’est un métier",
        text: "Vous savez qu’être présent en ligne est essentiel, mais comment s’y prendre ? Entre publicité, gestion des réseaux sociaux et optimisation de votre site internet, cela devient vite un vrai casse-tête.",
      },
      {
        title: "Faire appel à plusieurs prestataires, c’est ingérable !",
        text: "Confier chaque service à un acteur différent ? Bien trop compliqué. Vous perdez du temps et de la cohérence en essayant de coordonner des prestataires qui ne travaillent pas main dans la main.",
      },
    ],
    // La communication enfin accessible aux petites entreprises
    communicationAccessibleArguments: [
      {
        image: "accessible-1",
        title: "Un budget maîtrisé",
        arguments: [
          "Des solutions étudiées pour les TPE lyonnaises",
          "Une communication professionnelle sans se ruiner",
          "Des offres flexibles et transparentes adaptées à vos besoins",
        ],
      },
      {
        image: "accessible-2",
        title: "Une équipe dédiée à votre réussite",
        arguments: [
          "Un seul interlocuteur du début à la fin",
          "Des conseils stratégiques alignés avec votre secteur local",
          "Des points réguliers pour suivre vos résultats",
        ],
      },
      {
        image: "accessible-3",
        title: "Un seul partenaire pour tout gérer",
        arguments: [
          "Création de site internet, réseaux sociaux, SEO, graphisme… tout au même endroit !",
          "Moins d’intermédiaires, plus d’efficacité",
          "Un suivi clair, simple et sans stress",
        ],
      },
    ],
    solutions: [
      {
        title: "Site web",
        price: "69",
        isPerMonth: true,
        description:
          "Boostez votre activité grâce à votre site internet clé en main.",
        link: "web",
        image: {
          path: "solution-web.png",
          width: "",
          height: "",
        },
      },
      {
        title: "Réseaux sociaux",
        price: "250",
        isPerMonth: true,
        description:
          "Développez votre notoriété et gagnez en crédibilité pour attirer de nouveaux clients.",
        link: "gestion-rs",
        image: {
          path: "solution-rs.png",
          width: "",
          height: "",
        },
      },
      // {
      //   title: "Google Maps",
      //   price: "129",
      //   isPerMonth: true,
      //   description:
      //     "Attirez plus de clients et boostez votre notoriété locale grâce à Google Maps.",
      //   link: "gmb",
      //   image: {
      //     path: "solution-gmap.png",
      //     width: "",
      //     height: "",
      //   },
      // },
      {
        title: "Publicité Google",
        price: "290",
        isPerMonth: true,
        description:
          "Générez plus de contacts en passant de visible à incontournable.",
        link: "seo",
        image: {
          path: "solution-seos-2.webp",
          width: "",
          height: "",
        },
      },
      {
        title: "Référencement naturel",
        price: "249",
        isPerMonth: true,
        description:
          "Boostez votre visibilité sur le web avec une stratégie de référencement naturel sur mesure.",
        link: "ref-naturel",
        image: {
          path: "solution-adgoogle.png",
          width: "",
          height: "",
        },
      },
      {
        title: "Graphisme",
        price: "400",
        isPerMonth: false,
        description:
          "Différenciez-vous et marquez les esprits de vos clients avec une image professionnelle.",
        link: "graphism",
        image: {
          path: "solution-graphisms.png",
          width: "",
          height: "",
        },
      },
    ],
    clients: [
      {
        review:
          "“Pour mes clients, je ne suis plus une petite indépendante. La communication a tout changé !”",
        photo: "client-2cvb.png",
        name: "Virginie",
        job: "Assurance",
      },
      {
        review:
          "“J’ai doublé mon chiffre d’affaires grâce à mon site internet.”",
        photo: "client-museau.png",
        name: "Alexa",
        job: "Salon de toilettage",
      },
      {
        review:
          "“Le professionnalisme et la réactivité d'ALEO m'ont permis de démarrer sereinement mon activité.”",
        photo: "client-cmeg.png",
        name: "Elsa",
        job: "Centre de médecine esthétique",
      },
      {
        review: "“Une très belle expérience et visibilité pour ma société !”",
        photo: "client-cars.png",
        name: "Jonathan",
        job: "Nettoyage de voitures",
      },
    ],
    partners: [
      {
        img: "logo-g-partners.png",
        alt: "ALEO - Google Partner",
      },
      {
        img: "logo-facebook.png",
        alt: "Partenaire Facebook",
      },
      {
        img: "logo-instagram.png",
        alt: "Instagram Partenaire",
      },
      {
        img: "logo-france-num.png",
        alt: "Activateur France Num",
      },
      {
        img: "logo-ma.png",
        alt: "Chambre des métiers et de l'artisanat",
      },
    ],
    step: 0,
    animation: null,
    simpleSteps: [
      {
        title: "Étape 1 : Appel découverte de 30 min",
        description:
          "On discute de vos objectifs et de vos besoins pour bien comprendre votre entreprise.",
        image: "serkan.jpg",
      },
      {
        title: "Étape 2 : Étude de votre activité",
        description:
          "On analyse votre marché et vos attentes pour définir une stratégie personnalisée.",
        image: "launch.jpg",
      },
      {
        title: "Étape 3 : Proposition personnalisée",
        description:
          "On vous présente les solutions digitales adaptées à votre entreprise avec les délais et le budget précis.",
        image: "study-activitiy.png",
      },
      {
        title: "Étape 4 : Lancement",
        description:
          "Une fois validée, on met en place la stratégie et lançons les actions pour vous rendre visible et attirer des clients.",
        image: "proposition.jpg",
      },
    ],
  }),
  head() {
    return {
      title: "Agence de communication à Lyon - ALEO AGENCY",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Boostez votre visibilité avec ALEO, agence de communication à Lyon : sites web, référencement, réseaux sociaux et graphisme adaptés aux TPE.",
        },
      ],
    };
  },

  mounted() {
    window
      .matchMedia("(min-width: 1024px)")
      .addEventListener("change", (event) => {
        event.matches ? (this.isDesktop = true) : (this.isDesktop = false);
      });

    this.watchMedia();
    this.$nextTick(() => {
      if (this.isDesktop) this.stepsAnimation();
    });
  },

  methods: {
    watchMedia() {
      window.matchMedia("(min-width: 1024px)").matches
        ? (this.isDesktop = true)
        : (this.isDesktop = false);
    },

    stepsAnimation() {
      const steps = document.querySelectorAll(".step");
      const loaders = document.querySelectorAll(".loader");

      if (this.step >= steps.length) this.step = 0;

      steps.forEach((step) => step.classList.remove("step--active"));
      loaders.forEach((loader) => (loader.style.width = "0%"));

      steps[this.step].classList.add("step--active");

      const loader = loaders[this.step];

      this.animation = loader.animate([{ width: "100%" }], { duration: 6000 });

      this.animation.finished.then(() => {
        if (this.step < steps.length - 1) {
          this.step++;
        } else {
          this.step = 0;
        }
        this.stepsAnimation();
      });

      const resetAnimation = (index) => {
        if (this.animation) {
          this.animation.cancel();
        }
        this.animation = null;
        loader.style.width = "0%";
        this.step = index;
        this.stepsAnimation();
      };

      if (!this.eventsAttached) {
        steps.forEach((step, i) => {
          step.addEventListener("click", () => resetAnimation(i));
        });
        this.eventsAttached = true;
      }
    },

    activeCalendly(
      link = "https://calendly.com/aleo-alpha/rendez-vous-decouverte-aleo/"
    ) {
      this.linkCalendly = link;
      this.isCalendlyActive = false;
      this.$nextTick(() => {
        this.isCalendlyActive = true;
      });
    },
  },
};
